import { Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard/dashboard.js";
import PagesError from "../pages/pages/error.js";
import LoginPage from "../auth/pages/LoginPage.jsx";
import ProtectedRoute from "../auth/components/ProtectedRoute.js";
import Settings from "../pages/pages/settings/settings.js";
import Tournaments from "../pages/pages/tournaments/tournaments.js";
import Participants from "../pages/pages/participants/participants.js";
import App from "../app.jsx";

const AppRoute = [
	{
		path: "",
		element: <App />,
		children: [
			{ path: "login", element: <LoginPage /> },
			{ path: "/", element: <Navigate to="/login" /> },
			{
				path: "/*",
				element: <ProtectedRoute />,
				children: [
					{
						path: "dashboard",
						element: <Dashboard />,
					},
					{
						path: "settings",
						element: <Settings />,
					},
					{
						path: "tournaments",
						element: <Tournaments />,
					},
					{
						path: "participants",
						element: <Participants />,
					},
					{ path: "*", element: <PagesError /> },
				],
			},
		],
	},
];

export default AppRoute;
